<template>
    <CRow>
        <CCol col="12" xl="8">
            <CCard>
                <CCardHeader>
                    <strong>Категории</strong>
                </CCardHeader>

                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <CategoriesListTable :data="list" />
                    </template>
                </CCardBody>

                <CCardFooter>
                    <CButton color="primary" @click="openDialog">Создать</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CategoriesUpsertDialog ref="upsertDialog" @success="fetch" />
    </CRow>
</template>

<script>
    import CategoriesListTable from '@/components/CategoriesListTable';
    import CategoriesUpsertDialog from '@/components/CategoriesUpsertDialog';

    export default {
        name: 'Categories',

        components: {
            CategoriesListTable,
            CategoriesUpsertDialog,
        },

        data: () => ({
            loading: true,
            list: [],
        }),

        async created() {
            await this.fetch();
            this.loadgin = false;
        },

        methods: {
            async fetch() {
                try {
                    const { data } = await this.axios.get('/categories');
                    this.list = data.map(item => {
                        item.enabled = Boolean(item.enabled);
                        item.empty = Boolean(item.empty);
                        return item;
                    });
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            openDialog() {
                this.$refs.upsertDialog.open();
            },
        },
    };
</script>
